import * as types from './types';

const getThresholdData = () => ({
  type: types.GET_THRESHOLD_DATA,
});

const saveThresholdData = (thresholdData, callback?) => ({
  type: types.SAVE_THRESHOLD_DATA,
  thresholdData,
  callback,
});

const setThresholdDisabledStatus = (status) => ({
  type: types.SET_THRESHOLD_ACTIVE_STATUS,
  status,
});

const saveAndRedirectThreshold = (thresholdData, history, callback?) => ({
  type: types.SAVE_THRESHOLD_AND_REDIRECT,
  history,
  thresholdData,
  callback,
});

export {
  getThresholdData,
  saveThresholdData,
  setThresholdDisabledStatus,
  saveAndRedirectThreshold,
};
